/**
 * These are the Patient permissions.
 */
// tslint:disable:variable-name
export const patientPermissions = {
  Read: "patientCanRead",
  Write: "patientCanWrite",
  Delete: "patientCanDelete"
};
